import React from 'react'
import Heading from '../../../atoms/Heading/Heading'

const AIHealthSolutions = () => {
    return (
        <div>
            <Heading className='bg-darkGreyPrimary pt-8 sm:pt-10 md:pt-12'
                subTitle='Our AI healthcare solutions we can create for you' />
            <div className="flex justify-center items-center pt-6 sm:pt-8 md:pt-12 px-4 sm:px-6 md:px-0">
                <ul className="grid grid-cols-2 sm:grid-cols-3 max-w-full sm:max-w-6xl px-2 sm:px-4 md:px-6 text-base sm:text-lg">
                    <li className=" border-[#272727] text-base sm:text-lg md:text-xl p-3 sm:p-4 md:p-6 pl-4 sm:pl-6">• AI-Driven analysis of medical images</li>
                    <li className="border-l border-t-0  border-[#272727] text-base sm:text-lg md:text-xl p-3 sm:p-4 md:p-6 pl-4 sm:pl-6 ">• Virtual health assistants</li>
                    <li className="border-l border-[#272727] text-base sm:text-lg md:text-xl p-3 sm:p-4 md:p-6 pl-4 sm:pl-6">• Using AI for managing electronic health records (EHR)</li>
                    <li className=" border-t border-[#272727] text-base sm:text-lg md:text-xl p-3 sm:p-4 md:p-6 pl-4 sm:pl-6 ">• Predictive analytics for patient health</li>
                    <li className="border-l border-t border-[#272727]  text-base sm:text-lg md:text-xl p-3 sm:p-4 md:p-6 pl-4 sm:pl-6">• Proactive patient care and health monitoring</li>
                    <li className="border-l border-t border-[#272727]  text-base sm:text-lg md:text-xl p-3 sm:p-4 md:p-6 pl-4 sm:pl-6 ">• Remote patient monitoring with AI</li>
                </ul>
            </div>
        </div>
    )
}

export default AIHealthSolutions
